import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as WarningIcon } from 'assets/message_open_error.svg';
import i18nContext from 'components/i18n-context';
import Button from 'uikit/Button/Button';

export const DeleteWebhookScheme = ({ webhookUrl, isLoading, handleConfirm, closePopUp }) => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'scheme-wrapper pop-up-success delete webhook-delete-scheme'}>
      <WarningIcon />
      <h2 className={'scheme-success-header'}>{i18n.getMessage('webhookTab.delete.header')}</h2>
      <p className={'scheme-success-message'}>
        {i18n.getMessage('webhookTab.delete.message')} <strong className={'webhook-delete-url'}>{webhookUrl}</strong>
      </p>
      <div className={'scheme-wrapper-buttons'}>
        <Button
          className={'scheme-button'}
          size={'large'}
          type={'outline'}
          onClick={handleConfirm}
          isDisabled={isLoading}
        >
          {i18n.getMessage('webhookTab.delete.confirm')}
        </Button>
        <Button className={'scheme-error-button scheme-button'} size={'large'} onClick={closePopUp}>
          {i18n.getMessage('webhookTab.delete.cancel')}
        </Button>
      </div>
    </div>
  );
};

DeleteWebhookScheme.propTypes = {
  webhookUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  handleConfirm: PropTypes.func.isRequired,
  closePopUp: PropTypes.func.isRequired
};
